<div class="card-deal-item">

  <div class="mobile-card-box">
    <div class="section left">
      <div class="deal-date"><img class="small-icon" src="./assets/images/clock.png">{{formatDate(deal.dateCreated.value)}}</div>

        <div class="img-container"><img class="card-img" [src]="getCardImg()">
          <div *ngIf="deal.isExpired" class="img-overlay"></div>
        </div>

      <button type="button" class="blue-button deal-btn" (click)="grabDeal()" [class.expired]="deal.isExpired">{{getString('grabDeal')}}</button>
      
    </div>

    <div class="mobile-right-box">
      <div class="user-box deal-user">
        <img class="user-pic" [src]="getAuthorPic()">
        <div class="user-name">{{deal.author ? deal.author.username : ""}}</div>
      </div>

      <div class="report-expired" (click)="expiredPopup.open()">
        <img class="small-icon flag-icon" src="./assets/images/small_flag.png">
        {{getString('reportExpired')}}
      </div>
    </div>

  </div>

  <div class="section center" [class.show-all-notes]="showMore">
    <div class="txt-box">
      <span *ngIf="deal.isExpired" class="expired-box">{{getString('expired')}}</span>
      <a class="title" [routerLink]='getDealUrl()' [class.expired]="deal.isExpired"><h3>{{deal.title}}</h3></a>
      <div #notes class="notes" [class.show-all-notes]="showMore"><pre [innerHtml]="formatTextWithLinks(deal.notes)"></pre>
        <div [class.hidden]="!notesAreLong() || showMore" class="more" (click)="more()">[{{getString('more')}}]</div>
        <div [class.hidden]="!notesAreLong() || !showMore" class="less" (click)="less()">[{{getString('less')}}]</div>
      </div>
    </div>

    <div class="right-box">
      <div class="user-box deal-user">
        <img class="user-pic" [src]="getAuthorPic()">
        <div class="user-name">{{deal.author ? deal.author.username : ""}}</div>
      </div>

      <div class="report-expired" (click)="openExpiredPopup()">
        <img class="small-icon flag-icon" src="./assets/images/small_flag.png">
        {{getString('reportExpired')}}
      </div>
    </div>

    <div class="footer">
      <span>
      <span class="footer-item" *ngIf="deal.price > 0">{{formatPrice()}}</span>
      <span class="footer-item">{{shippingType[deal.shippingType]}}</span>
      <span class="footer-item">
        <a [href]="facebookShareURL()" target="_blank" (click)="shareClick('Facebook')"><img class="share-icon" src="./assets/images/share-fb.png"></a>
        <a [href]="twitterShareURL()" target="_blank" (click)="shareClick('Twitter')"><img class="share-icon" src="./assets/images/share-tw.png"></a>
        <a [href]="emailShareURL()" (click)="shareClick('Email')"><img class="share-icon" src="./assets/images/share-mail.png"></a>
        <div class="cp-tooltip" (click)="shareClick('Link')">
          <img class="share-icon" src="./assets/images/share-link.png" (click)="copyURL()" (mouseout)="linkOut()">
          <span class="cp-tooltiptext" [id]="'myCPTooltip' + deal.id">{{getString('copyToClipboard')}}</span>
        </div>
      </span>
      <span class="footer-item"><img class="small-icon" src="./assets/images/comments.png">
        <span class="comments-toggle" (click)="commentsClick()">{{getCommentsLength()}} {{getCommentsLength() == 1 ? getString('comment') : getString('comments')}}</span>
      </span>
    </span>
      <span>
        <span class="vote-btn" (click)="upvote()">
          <img class="small-icon" [class.green-icon]="deal.vote==1" src="./assets/images/thumbsup.png">{{deal.upvotes}}
        </span>
        <span class="vote-btn" (click)="downvote()">
          <img class="small-icon" [class.red-icon]="deal.vote==-1" src="./assets/images/thumbsdown.png">{{deal.downvotes}}
        </span>
      </span>
    </div>
    
  </div>

  <div class="comments" *ngIf="showComments == true">
    <div class="comments-title">{{getCommentsLength()}} {{getCommentsLength() == 1 ? getString('comment') : getString('comments')}}</div>
    <div *ngFor="let comment of deal.comments; let i = index;" class="comment-box">
      
      <div class="comment">
        <div class="user-box">
          <img class="user-pic" [src]="getCommentPic(comment)">
        </div>
        <div class="comment-info">
          <div class="comment-date">{{formatDate(comment.dateCreated.value)}}</div>
          <div class="user-name">{{comment.username}}</div>
          <pre class="comment-text" [innerHtml]="formatTextWithLinks(comment.text)"></pre>
        </div>
      </div>
      <div *ngFor="let comm of comment.comments; let j = index;" class="sub-comment-box">
        <div class="user-box">
          <img class="user-pic" [src]="getCommentPic(comm)">
        </div>
        <div class="comment-info">
          <div class="comment-date">{{formatDate(comm.dateCreated.value)}}</div>
          <div class="user-name">{{comm.username}}</div>
          <pre class="comment-text" [innerHtml]="formatTextWithLinks(comm.text)"></pre>
        </div>
      </div>
      <div class="answer-btn" [class.answer-btn-right]="comment.comments && comment.comments.length > 0" (click)="openAnswer(i)">{{getString('answer')}}</div>
      <div class="new-sub-comment" *ngIf="isAnswerOpen(i)">
        <div class="new-comment-title">{{getString('yourComment')}}</div>
        <textarea [(ngModel)]="newSubCommentText"></textarea>
        <div class="new-sub-comm-buttons">
          <button type="button" class="blue-button add-comment-btn" (click)="addCommentToComment(comment.id)">{{getString('addComment')}}</button>
          <button type="button" class="cancel-btn add-comment-btn" (click)="closeAnswer(i)">{{getString('cancel')}}</button>
        </div>
      </div>
    </div>

    <div class="new-comment">
      <div class="new-comment-title">{{getString('yourComment')}}</div>
      <textarea [(ngModel)]="newCommentText"></textarea>
      <button type="button" class="blue-button add-comment-btn" (click)="addComment()">{{getString('addComment')}}</button>
    </div>

  </div>

</div>

<app-modal #expiredPopup [title]="getString('reportExpired')" [confirmationModal]="true" 
  (onResult)="onExpiredConfirmationResult($event)">
  {{expirationPopupText}}
</app-modal>

<app-modal #expiredSuccessPopup [okModal]="true" [title]="getString('thankYou')">
  {{getString('thankYouForYourHelp')}}
</app-modal>
